require("../insights.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { Row, Col, FullRow } from "../../framework/Grid/";
import { splitNumber, timezonLabel } from "../../../utils/utility";
import LineGraphicSection from "../LineGraphic";

import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";

class TrafficSummary extends AcquireWebComponent {
  onClickContact(e) {
    e.preventDefault();
    if (this.props.handleContactSupport) {
      this.props.handleContactSupport();
    }
  }

  render() {
    const {
      data,
      dateRange,
      hideTraffic,
      chartTitle,
      client_profile,
    } = this.props;
    if (isUndefined(data)) {
      return (
        <div
          style={{
            border: "solid 1px black",
            color: "#5C5C5C",
            background: "#FFF",
          }}
        >
          <FullRow
            className="no-margin-bottom p-20"
            style={{ fontWeight: "300" }}
          >
            <div
              style={{
                float: "left",
                height: "200px",
                width: "100%",
                position: "relative",
                padding: "20px",
              }}
            >
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              &nbsp;loading...
            </div>
          </FullRow>
        </div>
      );
    }

    if (isEmpty(data)) {
      return (
        <div
          style={{
            border: "solid 1px black",
            color: "#5C5C5C",
            background: "#FFF",
            fontSize: "16px",
          }}
        >
          <FullRow className="no-margin-bottom pt-20 pb-20">
            <div
              style={{
                width: "100%",
                minHeight: "200px",
                textAlign: "center",
                paddingTop: "60px",
                color: "#CDCDCD",
              }}
            >
              <div
                style={{ color: "#CDCDCD", fontSize: "36px", opacity: "0.8" }}
              >
                No Data
              </div>
            </div>
          </FullRow>
        </div>
      );
    }
    const { totalVisitsCount, uniqueVisitsCount, detailVisitsCount } = data;
    const fontSize =
      totalVisitsCount > 100000 || uniqueVisitsCount > 100000 ? "48px" : "58px";
    return (
      <div
        style={{
          color: "#000",
          background: "#FFF",
          fontSize: "16px",
        }}
      >
        {hideTraffic ? null : (
          <div className="light-grey-border">
            <div className="mt-20 ml-20" style={{ height: "16px" }}>
              <p
                style={{ fontSize: "24px", height: "16px", fontWeight: "bold" }}
              >
                Traffic
              </p>
            </div>
            <div
              className="no-margin-bottom pt-10 pb-20"
              style={{ fontWeight: "300", display: "flex" }}
            >
              <div
                style={{
                  flexShrink: "0",
                  flexGrow: 1,
                  minWidth: "20%",
                }}
              >
                <div
                  style={{
                    color: "#000",
                    marginTop: "20px",
                    textAlign: "center",
                  }}
                >
                  Total Visits
                </div>
                <div
                  style={{
                    fontSize: fontSize,
                    fontWeight: "normal",
                    color: "#32A59D",
                    padding: "0 20px",
                    textAlign: "center",
                    lineHeight: 1,
                  }}
                >
                  {splitNumber(totalVisitsCount + "")()}
                </div>
              </div>
              <div
                className="pr-20 pl-20 light-grey-left-border"
                style={{ flexGrow: 1, minWidth: "40%" }}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    padding: "20px",
                    lineHeight: "18px",
                    background: "#F5F5F5",
                    marginBottom: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Traffic Breakdown
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {map(detailVisitsCount, (value, key) => {
                    return (
                      <div
                        className="stats-summary-count"
                        key={"stats-summary-" + key}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <strong>{key}</strong>: {value}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className="light-grey-left-border pt-5"
                style={{
                  justifyContent: "flex-end",
                  flexShrink: "0",
                  flexGrow: 1,
                  minWidth: "20%",
                }}
              >
                <div
                  style={{
                    color: "#000",
                    marginTop: "20px",
                    textAlign: "center",
                  }}
                >
                  Unique Visits
                </div>
                <div
                  style={{
                    fontSize: fontSize,
                    fontWeight: "normal",
                    color: "#32A59D",
                    padding: "0 20px",
                    textAlign: "center",
                    lineHeight: 1,
                  }}
                >
                  {splitNumber(uniqueVisitsCount + "")()}
                </div>

                {/*this.props.handleContactSupport &&
                <div
                  className="pull-left black-border p-10 "
                  style={{
                    background: "#FFFCDC",
                    width: "196px",
                    marginTop: "6px",
                  }}
                >
                  <a
                    onClick={e => {
                      this.onClickContact(e);
                    }}
                  >
                    Click here
                  </a>{" "}
                  to contact your client services representative to discuss ways
                  to engage this audience.
                  </div>
                  */}
              </div>
            </div>
          </div>
        )}
        <div className="no-margin-bottom light-grey-border mt-20 p-20 ">
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "40px",
            }}
          >
            {chartTitle ||
              "Total U.S. Domestic Traffic (includes Consumer and Business)"}
          </div>
          <LineGraphicSection
            type={"business"}
            animation={false}
            key={"triffice-summary-section"}
            title=""
            data={this.props.lineData}
            subTitle={
              client_profile && client_profile.timezone
                ? `${dateRange} - ${timezonLabel(client_profile.timezone)}`
                : `${dateRange}`
            }
          />
        </div>
      </div>
    );
  }
}

TrafficSummary.propTypes = {
  data: React.PropTypes.object,
  lineData: React.PropTypes.array,
  dateRange: React.PropTypes.string,
  handleContactSupport: React.PropTypes.func,
};

export default TrafficSummary;



// WEBPACK FOOTER //
// ./src/components/Insights/summary/TrafficSummary.jsx